import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddAgendaItem from './addagendaitem/index'
import AgendaItemList from './agendaitemlist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddAgendaItemProtected_ma = userIsCommitteeAdminRedir(AddAgendaItem)
const AgendaItemListProtected_ma = userIsCommitteeAdminRedir(AgendaItemList)

const AgendaItem = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* AgendaItem Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/agenda-item-list`} />
            <Route path={`${match.url}/add-agenda-item/:id?/:committee_id?`} component={AddAgendaItemProtected_ma} />
            <Route path={`${match.url}/agenda-item-list/:id?/:smeetingId?`} component={AgendaItemListProtected_ma} />
        </Switch>
    </div>
);

export default AgendaItem;



// WEBPACK FOOTER //
// ./app/agendaitemdetails/index.js